import { render, staticRenderFns } from "./productDynamicDetail.vue?vue&type=template&id=c66e7d8e&scoped=true&"
import script from "./productDynamicDetail.vue?vue&type=script&lang=js&"
export * from "./productDynamicDetail.vue?vue&type=script&lang=js&"
import style0 from "./productDynamicDetail.vue?vue&type=style&index=0&id=c66e7d8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c66e7d8e",
  null
  
)

export default component.exports